import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';

const YourRights = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Your Rights</h3>

      <p>
        Depending on where you are located and applicable privacy laws, you may
        have certain rights regarding your personal information. These may
        include:
      </p>

      <ul>
        <li>
          <strong>Access:</strong> You may request access to personal
          information we hold about you, subject to any limitations permitted or
          required by law.
        </li>
        <li>
          <strong>Correction:</strong> You may request that inaccurate or
          incomplete personal information be corrected or updated.
        </li>
        <li>
          <strong>Withdrawal of consent:</strong> Where we rely on your consent
          to collect, use, or disclose personal information, you may withdraw
          that consent, subject to legal or contractual restrictions and
          reasonable notice. Withdrawing consent may affect our ability to
          provide certain services or platform features.
        </li>
        <li>
          <strong>Marketing communications:</strong> You may unsubscribe from
          newsletters and promotional communications at any time using the
          unsubscribe method provided in those communications.
        </li>
        <li>
          <strong>Deletion or removal:</strong> You may request deletion or
          removal of certain personal information where permitted by applicable
          law. We may need to retain some information where reasonably necessary
          to meet legal, regulatory, accounting, security, contractual, or
          legitimate business requirements.
        </li>
        <li>
          <strong>Information about our privacy practices:</strong> You may
          contact us with questions about how your personal information is
          collected, used, disclosed, stored, or protected.
        </li>
        <li>
          <strong>Complaints:</strong> You may contact us with a concern or
          complaint regarding our handling of your personal information. You may
          also have the right to contact the appropriate privacy regulator or
          supervisory authority in your jurisdiction.
        </li>
      </ul>

      <p>
        To exercise a privacy right or make a request regarding your personal
        information, please contact us using the contact information provided in
        this Privacy Policy. We may need to verify your identity before
        completing certain requests.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default YourRights;
